
// ⚠️ Is file me sirf yahi constants honi chahiye — koi aur import NAHI
// (na axios, na kisi component ka, na Redux store ka), warna circular
// dependency wapas aa jayegi.

// Values .env.development (npm start) aur .env.production (npm run build)
// se aate hain — CRA khud sahi file uthata hai, yaha kuch switch nahi karna.
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const ImagebaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
// Secure channel (src/Utility/secureChannel.js) default ON hai. Sirf local
// debugging ke liye .env.development.local me REACT_APP_SECURE_CHANNEL=off
// rakh sakte ho — production me kabhi nahi.
export const REACT_APP_SECURE_CHANNEL = process.env.REACT_APP_SECURE_CHANNEL !== "off";
